import script from "./SheetMusicCreation.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetMusicCreation.vue?vue&type=script&setup=true&lang=ts"

import "./style.scss?vue&type=style&index=0&lang=scss"
import "./SheetMusicCreation.vue?vue&type=style&index=1&id=e27966cc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e27966cc"]])

export default __exports__